var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCopyLink = function SvgCopyLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.485 15.89a3.808 3.808 0 0 1-5.375 0 3.808 3.808 0 0 1 0-5.375l3.36-3.359a3.802 3.802 0 0 1 5.159-.204.715.715 0 0 1-.93 1.086 2.354 2.354 0 0 0-3.222.126l-3.36 3.36c-.938.939-.938 2.42 0 3.358.94.94 2.42.94 3.36 0l3.19-3.19a.714.714 0 1 1 1.009 1.007l-3.191 3.19Zm6.046-6.046a3.802 3.802 0 0 1-5.16.204.715.715 0 1 1 .93-1.086c.939.808 2.326.77 3.222-.126l3.36-3.36c.939-.938.939-2.419 0-3.358-.94-.94-2.42-.94-3.36 0l-3.19 3.19a.712.712 0 1 1-1.009-1.007l3.191-3.19a3.808 3.808 0 0 1 5.375 0 3.808 3.808 0 0 1 0 5.374l-3.36 3.359Z",
    fill: "#90A9C0",
    fillRule: "nonzero"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopyLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy_link.852fb400.svg";
export { ForwardRef as ReactComponent };